// 图表相关处理函数
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import tool from './tool';

function handleChangeInfo(changeInfo = []) {
  const temp = {
    largeRedemption: [],
    fundManagerChange: [],
    dividend: [],
  };
  changeInfo.forEach((item) => {
    const { STYPE, FSRQ } = item;
    const configMap = {
      1: 'largeRedemption',
      2: 'fundManagerChange',
      100: 'dividend',
    };
    if (['1', '2', '100'].indexOf(STYPE) >= 0) {
      const key = configMap[STYPE];
      temp[key].push(FSRQ);
    }
  });
  return temp;
}

function handleChartMaxReturn(changeInfo = [], maxReturnValue = '') {
  let maxReturnStartDate;
  let maxReturnEndDate;
  changeInfo.forEach((item) => {
    const { STYPE, FSRQ } = item;
    if (STYPE === '31') {
      maxReturnStartDate = FSRQ;
    } else if (STYPE === '32') {
      maxReturnEndDate = FSRQ;
    }
  });
  return {
    maxReturnStartDate,
    maxReturnEndDate,
    maxReturnValue,
  };
}

function formateLegendList(list) {
  return list.map((item) => {
    const { isRateValue } = item;
    const fontColor = isRateValue ? tool.getRateColor(item.value) : '#000000';
    let value = '--';
    if (!isEmpty(item.value)) {
      value = !isEmpty(item.valueFormatter) ? item.valueFormatter(item.value)
        : parseFloat(item.value)?.toFixed(2);
      value = `${value}${item.valueSymbol}`;
    }
    // const value = isEmpty(item.valueSymbol) ? item.value : `${item.value}${item.valueSymbol}`;
    return { ...item, fontColor, value };
  });
}

export default {
  handleChangeInfo,
  handleChartMaxReturn,
  formateLegendList,
};
